import type { Logger as LoggerInstance } from './logger';
import { ConsoleLogger } from './impl/console';

/**
 * Get the logger instance (browser-side - uses Console)
 */
function getLogger(): LoggerInstance {
  return ConsoleLogger;
}

export { getLogger };

